const NF = new Intl.NumberFormat('pl-PL');
const NF_PLN = new Intl.NumberFormat('pl-PL', {
  style: 'currency',
  currency: 'PLN',
  maximumFractionDigits: 0,
});

export function formatNumber(n: number): string {
  return NF.format(Math.round(n));
}

export function formatPLN(n: number): string {
  return NF_PLN.format(Math.round(n));
}
